export const releaseNotesDe: ReleaseNotes = [
    {
        release: "2.7.3",
        date: "2026-10-29",
        tags: [
            "Maßnahmen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Die Zuschuss-Quote einer Maßnahme kann Nachkommastellen haben (z. B. 99,5 %). Der berechnete Zuschussbetrag wird dann wieder vorgeschlagen."
            }
        ]
    },
    {
        release: "2.7.2",
        date: "2026-10-26",
        tags: [
            "Formulare"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Bei Kleinprojekten (AV3) und Aktivitäten (AV5) müssen die Gesamteinnahmen den Gesamtkosten entsprechen, eine Über- oder Unterfinanzierung lässt sich nicht mehr abgeben."
            }, {
                "description": "Für den Eigenanteil von 10 % der Gesamtkosten zählen bei Kleinprojekten und Aktivitäten alle Eigenmittel mit, also auch Teilnehmerbeiträge, Verkaufs- und Anzeigenerlöse sowie sonstige Einnahmen. Die Fehlermeldung nennt die mitzählenden Felder."
            }
        ]
    },
    {
        release: "2.7.1",
        date: "2026-10-22",
        tags: [
            "Weiterleitungsverträge", "Export"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Beim Drucken mehrerer Formulare einer Maßnahme bleibt eine hochgeladene unterschriebene PDF eines Weiterleitungsvertrags erhalten und erscheint vollständig im Ausdruck."
            }, {
                "description": "Der Einzeldruck eines Weiterleitungsvertrags mit hochgeladener unterschriebener PDF funktioniert wieder."
            }, {
                "description": "Schlägt ein Export fehl, bleiben keine temporären Dateien mehr auf dem Server zurück."
            }
        ]
    },
    {
        release: "2.7.0",
        date: "2026-10-21",
        tags: [
            "Word-Vorlagen", "E-Mails", "Förderprogramme"
        ],
        type: "minor",
        notes: [
            {
                "description": "Neue Platzhalter für den nationalen Weiterleitungsvertrag: die Maßnahmen der Organisation im Förderbereich und Jahr als Tabelle sowie gemeinsame Summen für Jugendverbandsarbeit und politische Bildung."
            }, {
                "description": "In der Förderprogramm-Verwaltung lässt sich festlegen, in welche Summe des Weiterleitungsvertrags die Maßnahmen eines Unterprogramms einfließen."
            }, {
                "description": "Neue Variablen für E-Mail-Vorlagen, darunter die Liste der Maßnahmen der Organisation im Förderbereich und Jahr."
            }
        ],
        fixes: [
            {
                "description": "Die Summen im Weiterleitungsvertrag hängen nicht mehr davon ab, wer das Dokument erzeugt."
            }, {
                "description": "Die E-Mail-Variable „Formulartyp“ ist jetzt für alle Formulare gefüllt, auch für Zielvereinbarung, Weiterleitungsvertrag, Auswertung, Prüfvermerk und Endbewilligung."
            }
        ]
    },
    {
        release: "2.6.1",
        date: "2026-10-15",
        tags: [
            "Word-Vorlagen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Neuer Platzhalter für Word-Vorlagen, der Begründung und Berechnung der Sprachmittler-Kosten nur eindruckt, wenn ein Sprachmittler benötigt wird."
            }
        ]
    },
    {
        release: "2.6.0",
        date: "2026-10-15",
        tags: [
            "Maßnahmen", "Formulare", "Jahre", "Datenschutz", "Word-Vorlagen", "E-Mails"
        ],
        type: "minor",
        notes: [
            {
                "description": "Das Anlegen neuer Maßnahmen lässt sich im Jahr jetzt je Förderbereich freischalten statt für das ganze Jahr. Formulare zu bestehenden Maßnahmen, etwa der Verwendungsnachweis, können weiterhin hinzugefügt werden."
            }, {
                "description": "Neuer Maßnahmenstatus „Storniert“ für Maßnahmen, die vom Antragsteller zurückgezogen wurden. Stornierte und abgelehnte Maßnahmen sind vollständig gesperrt."
            }, {
                "description": "Neue Seite mit den Informationen zur Datenverarbeitung nach § 17 DSG-EKD. Bei der Registrierung muss sie bestätigt werden, bestehende Nutzer sehen einmalig einen Hinweis."
            }, {
                "description": "Das Tagesprogramm in den internationalen Formularen wird nur noch als PDF-Datei hochgeladen. Der Upload ist verpflichtend."
            }, {
                "description": "In der Maßnahmenübersicht im Antragsbereich gibt es „Dokumente hinzufügen“ jetzt als eigenen Button."
            }, {
                "description": "Die Maßnahmenübersicht im Verwaltungsbereich zeigt bei Zuschuss, Dokumenten und Bemerkungen an, was der Antragsteller davon sieht."
            }, {
                "description": "Neue Platzhalter für Word-Vorlagen, die bei den Reisekostenzuschüssen der internationalen Begegnungen nur die gewählte Option mit Berechnung eindrucken."
            }, {
                "description": "In der nationalen Zielvereinbarung und Zielerreichung wird die protokollführende Person abgefragt."
            }, {
                "description": "Bei den Honorarkräfte-Tagen in den Kursen und Arbeitstagungen erklärt ein Hilfetext die Obergrenze."
            }, {
                "description": "Alle Texte und globalen E-Mail-Vorlagen sprechen einheitlich mit „Sie“ an. Der Produktname lautet jetzt oase_aej."
            }, {
                "description": "Hochgeladen werden können nur noch PDF-, Word-, Excel- und Bilddateien."
            }
        ],
        fixes: [
            {
                "description": "Ein Formular, das einer bestehenden Maßnahme hinzugefügt wird, erhält jetzt immer das Jahr der Maßnahme und rechnet mit dessen Sätzen."
            }, {
                "description": "In den Formularen AV5 AVK1 wird jetzt das Datum der Veranstaltung abgefragt."
            }, {
                "description": "Berichte für einen Verband verwenden jetzt die Daten des gewählten Verbands statt die der ersten Organisation."
            }, {
                "description": "Tabellen bleiben benutzbar, wenn zuvor nach einer Spalte sortiert wurde, die nicht mehr sortierbar ist."
            }
        ]
    },
    {
        release: "2.5.1",
        date: "2026-10-13",
        tags: [
            "Fehlermeldungen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Die Fehlermeldung bei Serverfehlern nennt jetzt eine erreichbare Support-Adresse."
            }
        ]
    },
    {
        release: "2.5.0",
        date: "2026-10-12",
        tags: [
            "Formulare", "Export"
        ],
        type: "minor",
        notes: [
            {
                "description": "Zielvereinbarungen und Auswertungen im internationalen Bereich wurden an die neuen Vorlagen angepasst."
            }, {
                "description": "Der PDF-Export ist schneller und auch auf der Formularseite für die Verwaltung verfügbar."
            }
        ]
    },
    {
        release: "2.4.0",
        date: "2026-10-07",
        tags: [
            "Nutzerverwaltung", "Organisationen", "Benachrichtigungen", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Neue Benachrichtigung: Wird ein Nutzer mit einer Organisation verknüpft, auch bei der Registrierung mit dem Authentifizierungscode, erhalten die Administrationsrollen dieser Organisation eine Benachrichtigung."
            }, {
                "description": "Beim Anlegen einer Organisation im Antragsbereich ist die aktive Organisation als übergeordnete Organisation vorausgewählt. Zur Auswahl stehen nur die aktive Organisation und ihre Untergliederungen."
            }, {
                "description": "Verknüpfungen von Nutzern mit Organisationen lassen sich nur noch für die aktive Organisation und ihre Untergliederungen bearbeiten, und nur mit Rollen, die man selbst vergeben darf. Andernfalls zeigt das Menü einen Hinweis."
            }, {
                "description": "Auf der Registrierungsseite stehen die Ansprechpersonen der Mitgliedsorganisation jetzt vor dem Kontakt der aej."
            }
        ],
        fixes: [
            {
                "description": "Ist ein Nutzer mit mehreren Organisationen verknüpft, bleiben beim Speichern seiner Nutzerdaten wieder alle Verknüpfungen erhalten."
            }, {
                "description": "Die Nutzerseite ist im Verwaltungsbereich nicht mehr fälschlich gesperrt. Ob sie bearbeitbar ist, richtet sich in beiden Bereichen nach der Organisation des angezeigten Nutzers."
            }, {
                "description": "Beim vorzeitigen Maßnahmenbeginn in den internationalen Anträgen wird jetzt das Jahr vor dem Haushaltsjahr genannt."
            }
        ]
    },
    {
        release: "2.3.3",
        date: "2026-09-10",
        tags: [
            "Endbewilligung", "Formulare", "Word-Vorlagen", "Unterschriften"
        ],
        type: "minor",
        notes: [
            {
                "description": "Neue Formularart „Endbewilligung“: Im internationalen Bereich kann der Verwaltungsbereich zu einer bewilligten Maßnahme eine Endbewilligung anlegen, bestätigen und als Word-Dokument herunterladen. Die Maßnahme erhält dabei den neuen Status „EB Abgeschlossen“."
            }, {
                "description": "Neue Platzhalter für Word-Vorlagen, die Werte aus dem zugehörigen Verwendungsnachweis übernehmen."
            }, {
                "description": "Der Authentifizierungscode einer Organisation ist nur noch für die Administrationsrollen sichtbar."
            }, {
                "description": "Der Button zum Bestätigen eines Formulars zeigt jetzt einen Hinweis, wenn die Bestätigung im aktuellen Status nicht möglich ist, statt ohne Rückmeldung zu bleiben."
            }
        ],
        fixes: [
            {
                "description": "In Formularen mit ausländischer Gruppe erscheint bei den Fahrtkosten nicht mehr die Meldung „Teilnehmer darf maximal 0 betragen“, wenn die Gruppengröße nachträglich geändert wurde."
            }
        ]
    },
    {
        release: "2.3.2",
        date: "2026-09-01",
        tags: [
            "Word-Vorlagen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Die Auflistung der ausländischen Partner, die bisher geförderten Maßnahmen und der Tagesplan werden in Word-Vorlagen wieder bündig zum umgebenden Text eingerückt."
            }
        ]
    },
    {
        release: "2.3.1",
        date: "2026-09-01",
        tags: [
            "Word-Vorlagen", "Formulare", "Unterschriften"
        ],
        type: "bugfix",
        notes: [
            {
                "description": "Die Auflistung der ausländischen Partner in Word-Vorlagen ist übersichtlicher: Bezeichnung und Wert stehen nebeneinander, Telefon und E-Mail teilen sich eine Zeile."
            }, {
                "description": "Das Feld für eine abweichende Kontaktperson enthält jetzt einen Hilfetext."
            }
        ],
        fixes: [
            {
                "description": "Unterschriften lassen sich jetzt auch dann speichern, wenn sie besonders großflächig gezeichnet wurden."
            }
        ]
    },
    {
        release: "2.3.0",
        date: "2026-08-27",
        tags: [
            "Word-Vorlagen", "Formulare", "E-Mails"
        ],
        type: "minor",
        notes: [
            {
                "description": "Neue Platzhalter für Word-Vorlagen: Maßnahmen, Zeitplan und Kontaktpersonen einer Veranstaltung können in Exporte übernommen werden."
            }, {
                "description": "Der Hilfetext zum Veranstaltungsnamen in den KJP-IB- und IWC-Formularen enthält jetzt Beispiele für passende Titel."
            }, {
                "description": "Die Formularart wird nicht mehr zusätzlich im Formularkopf angezeigt."
            }
        ],
        fixes: [
            {
                "description": "Word-Vorlagen geben den Wert 0 wieder aus, statt das Feld leer zu lassen."
            }, {
                "description": "Bei den Status-Benachrichtigungen findet die Auswahl der Mail-Vorlage jetzt auch mit kurzen Suchbegriffen Treffer."
            }, {
                "description": "Der Filter nach Mail-Vorlage in der Mail-Übersicht liefert jetzt die passenden Einträge."
            }, {
                "description": "Im Abschnitt „3. Finanzierung“ stehen die Felder „Welche Stiftung?“ und „Welches EU-Programm?“ jetzt bündig unter den übrigen Feldern."
            }, {
                "description": "Der Hinweis zu den bisher durchgeführten Maßnahmen nennt jetzt eindeutig die letzten fünf abgeschlossenen Jahre."
            }
        ]
    },
    {
        release: "2.2.1",
        date: "2026-08-20",
        tags: [
            "Word-Vorlagen", "Export", "Sicherheit"
        ],
        type: "minor",
        notes: [
            {
                "description": "Neuer Platzhalter für Word-Vorlagen: Der Belegtext des Antragstellers kann jetzt in Exporte übernommen werden."
            }, {
                "description": "Die ausländischen Partner einer Maßnahme werden über einen einzigen Platzhalter als vollständige Auflistung eingefügt."
            }, {
                "description": "Länderfelder geben in Word-Vorlagen den ausgeschriebenen deutschen Ländernamen aus statt des Länderkürzels."
            }
        ],
        fixes: [
            {
                "description": "Mahnungen und Erinnerungen werden weiter verschickt, auch wenn eine einzelne E-Mail nicht zugestellt werden kann."
            }, {
                "description": "Sicherheitsoptimierungen"
            }
        ]
    },
    {
        release: "2.2.0",
        date: "2026-08-18",
        tags: [
            "Export-Vorlagen",
        ],
        type: "minor",
        notes: [
            {
                "description": "Erweiterung der Platzhalter für Word-Vorlagen"
            }
        ]
    },
    {
        release: "2.1.0",
        date: "2026-08-07",
        tags: [
            "Startseite"
        ],
        type: "minor",
        notes: [
            {
                "description": "Startseite mit Übersicht über die wichtigsten Funktionen hinzugefügt"
            }
        ]
    },
    {
        release: "2.0.0",
        date: "2026-08-04",
        tags: [
            "Formulare", "Organisationen", "Maßnahmen", "Zahlungen", "Verbände"
        ],
        type: "major",
        notes: [
            {
                "description": "Start des Systems für die Arbeitsgemeinschaft der Evangelischen Jugend (aej)"
            }, {
                "description": "Digitale Formulare für die verschiedenen KJP-Förderbereiche mit digitaler Unterschrift"
            }, {
                "description": "Verwaltung von Organisationen, Maßnahmen und Personen"
            }, {
                "description": "Verwaltung von Zahlungsläufen"
            }, {
                "description": "Nutzer*innen- und Rollenverwaltung, E-Mailvorlagen und Auswertungen"
            }
        ]
    }
]
